import React, { useMemo } from "react";
import { Box } from "@mui/material";

import { Project } from "fond/types";
import { AccordionStepper, AccordionStepperPane, StackedNavigation } from "fond/widgets";

import DataModificationPanel from "./DataModificationPanel";
import ExcludeDrawPanel from "./ExcludeDrawPanel";

interface ScenarioPanelProps {
  // The project currently being viewed / edited
  project: Project;

  // Flag indicating if the project is read only
  readOnly: boolean;

  versionId: string;
}

const scenarioStackedNavigationPanels: Array<{ id: string; name: string; component: React.ReactNode; useDefaultHeader?: boolean }> = [
  {
    id: "dataModification",
    name: "Data modification",
    component: <DataModificationPanel />,
  },
  {
    id: "excludeDraw",
    name: "Exclude service locations",
    useDefaultHeader: false,
    component: <ExcludeDrawPanel />,
  },
];

const ScenarioPanel: React.FC<ScenarioPanelProps> = ({ project, readOnly, versionId }: ScenarioPanelProps) => {
  const accordionPanes: AccordionStepperPane[] = useMemo(
    () => [
      {
        header: "Data modification",
        id: "input",
        content: <DataModificationPanel />,
        isComplete: false,
        isLoading: false,
      },
    ],
    []
  );

  if (!project) return null;

  return (
    <Box data-testid="nbn-cost-to-serve-scenario-panel" sx={{ height: "100%" }}>
      <StackedNavigation
        rootComponent={<AccordionStepper id={versionId} panes={accordionPanes} autoMove={["input"]} />}
        screens={scenarioStackedNavigationPanels}
      />
    </Box>
  );
};

export default ScenarioPanel;
